import { render, staticRenderFns } from "./EditPaystub.vue?vue&type=template&id=049b7798&"
import script from "./EditPaystub.vue?vue&type=script&lang=js&"
export * from "./EditPaystub.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports